const PARTNER_GROUP_PATTERN = /^(partner-id-.+|fd\d+)$/
const PARTNER_GROUP_SUPERUSER_PREFIX = 'partner-group-super-user:'

export const getPartnerGroups = (groups) =>
  groups.filter((group) => PARTNER_GROUP_PATTERN.test(group))

export const isPartnerGroupSuperUser = (groups) =>
  groups.some((group) => group.startsWith(PARTNER_GROUP_SUPERUSER_PREFIX))

// A partner-group super user's accessible partners come from /profile/my-groups,
// not from their own cognito groups, so one own partner group doesn't mean one
// partner.
export const hasSinglePartner = (user) =>
  user.cognitoGroups?.length === 1 && !user.isPartnerGroupSuperUser

export const hasMultiplePartners = (user) =>
  user.cognitoGroups?.length > 1 || Boolean(user.isPartnerGroupSuperUser)
